import { Text } from '@/components'
import { PieChartIcon } from '@radix-ui/react-icons'

export const DetailBox: React.FC<{
  title: string
  count: number | string
  loading?: boolean
}> = ({ title, count, loading }) => (
  <div className="h-32 w-full lg:w-32 bg-glow/7 hover:bg-glow/15 rounded-xl flex flex-col justify-center items-center gap-2">
    <Text variant="paragraphSmall">{title}</Text>
    <Text variant="heading" className="text-glow-900 font-bold">
      {(loading && <PieChartIcon className="animate-spin" />) || count}
    </Text>
  </div>
)
